export default "__VITE_ASSET__B$FnCmgv__";